import logger from '../../logger'
import HttpStatus from '../httpStatus'

export const isErrorRejected = '__IS_ERROR_REJECTED__'

const apiErrorHandler = error => {
  if (error.response) {
    const { status } = error.response
    const { url, method, params, data } = error.config

    if (![HttpStatus.UNAUTHORIZED, HttpStatus.FORBIDDEN].includes(status)) {
      logger.error('api error occured', {
        status,
        url,
        method,
        params,
        data,
        responseData: error.response.data,
      })
    }
    if (data && JSON.parse(data)[isErrorRejected]) {
      return Promise.reject(error)
    }
  } else if (![HttpStatus.UNAUTHORIZED, HttpStatus.FORBIDDEN].includes(error.statusCode)) {
    const { url, method, params, data } = error.config

    logger.error('api error occured', {
      url,
      method,
      params,
      data,
    })
  }
  return Promise.resolve(null)
}

export default apiErrorHandler
